import moment from "moment";

/**
 * Function to generate dates and corresponding week numbers within a period
 * @param {string} startDateString - The start date in "YYYY-MM-DD" format
 * @param {string} endDateString - The end date in "YYYY-MM-DD" format
 * @returns {object} - An object containing all dates, unique weeks, and grouped dates by week
 */
export const GenerateDateAndWeekNo = (startDateString, endDateString) => {
    let weeks = {};
    let weeks2 = {};
    const dates = [];

    // Initialize start and end dates using Moment.js
    const date = moment(startDateString, "YYYY-MM-DD");
    const endDate = moment(endDateString, "YYYY-MM-DD");

    // Adjust start date to the beginning of the week (Monday)
    if (date.isoWeekday() !== 1) {
        date.subtract(date.isoWeekday() - 1, "days");
    }

    // Adjust end date to the end of the week (Sunday)
    if (endDate.isoWeekday() !== 7) {
        endDate.add(7 - endDate.isoWeekday(), "days");
    }

    // Iterate through each day in the range
    while (date.isSameOrBefore(endDate)) {
        const newDate = date.format("YYYY-MM-DD");
        const newDay = date.format("ddd"); // Short day name
        const weekNo = date.isoWeek(); // ISO week number
        const year = date.isoWeekYear(); // ISO week year for correct transitions

        // Add date information to the dates array
        dates.push({
            date: newDate,
            day: newDay,
            weekNo: weekNo,
        });

        // Generate a week-year key
        const wNo = `${weekNo}-${year}`;

        // Populate weeks and weeks2 objects
        weeks[wNo] = wNo;

        if (!weeks2[wNo]) {
            weeks2[wNo] = [];
        }

        weeks2[wNo].push({
            date: newDate,
            day: newDay,
            weekNo: weekNo,
        });

        // Increment the date by one day
        date.add(1, "day");
    }

    // Generate an array of unique week-year combinations
    const allWeeks = Object.keys(weeks);

    return {
        allDates: dates, // List of all dates with day and week information
        allWeeks, // Array of unique weeks in the range
        weeks2, // Grouped dates by week
    };
};

/*// Example usage
const exampleResult = GenerateDateAndWeekNo("2024-12-01", "2024-12-31");
console.log("All Dates:", exampleResult.allDates);
console.log("All Weeks:", exampleResult.allWeeks);
console.log("Grouped Weeks:", exampleResult.weeks2);*/
